import { IronIcon } from './IronIcon';

/**
 * author: Google
 * id 43DA7407-CFBA-44CE-9857-D75DF5581CE2
 * name iron
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/iron.svg
 * tags
 * - Home Automation 
 * - Clothing 
 */
export const FlatironIcon = IronIcon;
export default FlatironIcon